/* eslint-disable */
/*
使用方法说明
1.生成容器:var oB=new BallBox(‘bubbleContainer’);
注：容器必须是有宽高的定位元素。尽量不要有边线。
2.生成小球:var ball=new Ball();
3.把小球放入容器:	oB.addBall(ball);
4.调用容器的ballRun方法，让小球开始运动: oB.ballRun();

参数说明
容器参数  new BallBox(‘container’，opts);
opts:{width:num,height:num}//没有边线和padding的时候可不写。有的情况下需要把容器真实宽高填进去。
小球参数 new Ball(opts);
opts:{
	e:小球DOM元素/原生对象，可填入页面DOM，不写则生成新DIV DOM,
	b:小球半径 默认30;包含边
	c:小球背景颜色/图片， 默认'pink'
	borderWidth:边线宽度 默认0
	x:小球中心点的横坐标 默认为半径
	y:小球中心点的纵坐标 默认为半径
	sx:小球在x轴方向速度每30ms，默认3
	sy:小球在y轴方向速度每30ms，默认3
	m:小球的质量，默认b/30;
	html:小球内部的内容，不填则不会改变DOM本身的内容。
	callBack:function  碰撞时的回掉函数，参数为碰撞的总次数，方法中this指向此球对象
}*/
let offsetX = '';
let offsetY = '';
let dv = null;
let isDragging = false;
let letterWrapperIndex = 0;
let ball = null;
//点击时位置
let oldTransform = '';

function BallBox(a) {
	var c = this.container = document.getElementById(a);
	var b = this.opts = b || {};
	this.width = b.width || c.offsetWidth;
	this.height = b.height || c.offsetHeight;
	this.child = [];
};
BallBox.prototype.addBall = function(a) {
	this.child.push(a);
	letterWrapperIndex = 0;
	if (a.e.parentNode != this.container) {
		this.container.appendChild(a.e);
	}
};
BallBox.prototype.ballRun = function() {
	clearInterval(this.ballRunTimer);
	var g = this;
	var w = this.width;
	var h = this.height;
	var k = this.isColl;
	var l = this.coll;
	this.ballRunTimer = setInterval(function() {
		var a = g.child;
		var c = a.length;
		for (var i = 0; i < c; i++) {
			a[i].foot()
		}
		for (var i = 0; i < c; i++) {
			var d = a[i];
			var b = d.b;
			if (d.x < b) {
				d.x = b;
				d.sx *= -1
			}
			if (d.y < b) {
				d.y = b;
				d.sy *= -1
			}
			var e = w - b;
			if (d.x > e) {
				d.x = e;
				d.sx *= -1
			}
			var f = h - b;
			if (d.y > f) {
				d.y = f;
				d.sy *= -1
			}
		}
	}, 150)
};
BallBox.prototype.ballStop = function() {
	clearInterval(this.ballRunTimer)
};
BallBox.prototype.coll = function(a, b) {
	var c = b.x - a.x;
	var d = b.y - a.y;
	var e = b.sx - a.sx;
	var f = b.sy - a.sy;
	var g = Math.atan2(f, e);
	var h = Math.atan2(-d, -c);
	var i = Math.abs(h - g);
	var D = Math.PI / 2;
	if (i <= 3 * D && i >= D) return;
	var j = a.m || 1;
	var k = b.m || 1;
	var l = j + k;
	var m = ((j - k) * a.sx + 2 * k * b.sx) / l;
	var n = ((k - j) * b.sx + 2 * j * a.sx) / l;
	var o = ((j - k) * a.sy + 2 * k * b.sy) / l;
	var p = ((k - j) * b.sy + 2 * j * a.sy) / l;
	a.sx = m;
	a.sy = o;
	b.sx = n;
	b.sy = p
};
BallBox.prototype.isColl = function(a, b) {
	if (a.stopfoot || b.stopfoot) return false;
	var d = Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
	var c = Math.pow(a.b + b.b, 2);
	return d < c
};

function Ball(a) {
	var a = this.json = a || {};
	var d = this.type = a.type || 'ball';
	var b = this.b = a.b || 30;
	var f = this.borderWidth = a.borderWidth || 0;
	var x = this.x = a.x || b;
	var y = this.y = a.y || b;
	var h = this.sx = a.sx || 3;
	var i = this.sy = a.sy || 3;
	var m = this.m = a.m || (b / 30);
	var c = this.c = a.c || 'pink';
	var e = this.e = a.e || document.createElement('div');
	var j = this.html = a.html;
	var k = this.class = a.class; 
	var n = this.callBack = a.callBack || function() {};
	this.collNum = 0;
	this.initStyle();
	this.addEvent()
}
Ball.prototype.initStyle = function() {
	var b = this.b;
	var s = this.e.style;
	this.e.className = this.class;
	s.position = 'absolute';
	s.top = s.left = 0;
	s.width = s.height = (b - this.borderWidth) * 2 + 'px';
	s.borderRadius = '50%';
	s.background = this.c;
	s.backgroundSize = 'cover';
	if (this.html) {
		this.e.innerHTML = this.html;
		s.textAlign = 'center';
		s.lineHeight = (b - this.borderWidth) * 2 + 'px';
	}
	this.setPos()
};
Ball.prototype.addEvent = function() {
	var a = this;
	if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)){
		a.e.addEventListener('touchstart', () => a.startDrag(a));
		window.addEventListener('touchmove', a.dragging);
		window.addEventListener('touchend', a.endDrag);
	} else {
		a.e.addEventListener('mousedown', () => a.startDrag(a));
		window.addEventListener('mousemove', a.dragging);
		window.addEventListener('mouseup', a.endDrag);
	}
};
Ball.prototype.foot = function(n) {
	if (this.stopfoot) return;
	var n = n || 1;
	this.x += this.sx * n;
	this.y += this.sy * n;
	this.setPos()
};
Ball.prototype.startFoot = function() {
	this.stopfoot = false;
	this.e.style.zIndex = 1;
};
Ball.prototype.stopFoot = function() {
	this.stopfoot = true;
	this.e.style.zIndex = 999;
};
Ball.prototype.setPos = function() {
	var b = this.b;
	var x = parseInt(this.x - b);
	var y = parseInt(this.y - b);
	this.e.style.transform = 'translate(' + x + 'px,' + y + 'px)';
	this.e.style.webkitTransform = 'translate(' + x + 'px,' + y + 'px)';
};
Ball.prototype.startDrag = function(a) {
	ball = a;
	ball.stopFoot();
	event.stopPropagation();
	dv = event.currentTarget;
	oldTransform = dv.style.transform;
	dv.style.transform = `${oldTransform} scale(1.2)`;
	ball.callBack('playSounds');
	let touch = null;
	if (event.touches) {
		touch = {
			clientX: event.touches[0].clientX,
			clientY: event.touches[0].clientY,
		};
	} else {
		touch = event;
	}
	offsetX = touch.clientX - dv.getBoundingClientRect().left;
	offsetY = touch.clientY - dv.getBoundingClientRect().top;
	isDragging = true;
}
Ball.prototype.dragging = function(e) {
	if (isDragging) {
		let touch = null;
		if (e.touches) {
			touch = {
				clientX: e.touches[0].clientX,
				clientY: e.touches[0].clientY,
			};
		} else {
			touch = e;
		}
		const bC = document.getElementById('bubbleContainer');
		const x = touch.clientX - offsetX - bC.getBoundingClientRect().left;
		const y = touch.clientY - offsetY - bC.offsetTop;
		dv.style.left = x + 'px';
		dv.style.top = y + 'px';
		dv.style.transform = 'scale(1.2)';
		dv.style.webkitTransform = 'scale(1.2)';
		const container = document.getElementById('letterWrapper');
    const conT = container.offsetTop;
    const conB = conT + container.clientHeight;
    const conL = container.getBoundingClientRect().left;
    const conR = conL + container.clientWidth;
		// 字母摆放区域添加否则回到原来位置
		if (((x + bC.getBoundingClientRect().left > conL && x + bC.getBoundingClientRect().left < conR)
			|| (x + bC.getBoundingClientRect().left + dv.clientWidth > conL && x + bC.getBoundingClientRect().left + dv.clientWidth < conR)) 
			&& ((y + bC.offsetTop > conT && y + bC.offsetTop < conB)
			|| (y + bC.offsetTop < conT && y + bC.offsetTop + dv.clientHeight > conB)
			|| (y + bC.offsetTop + dv.clientHeight > conT && y + bC.offsetTop + dv.clientHeight < conB))) {
			container.className = 'letter-wrapper hover';
			container.childNodes[letterWrapperIndex].className = 'hover';
			dv.className = 'hover';
		} else {
			container.className = 'letter-wrapper';
			container.childNodes[letterWrapperIndex].className = '';
			dv.className = '';
		}
	}
};
Ball.prototype.endDrag = function() {
	if (isDragging) {
		const lW = document.getElementById('letterWrapper');
		const bW = document.getElementById('bubbleContainer');
		if (lW.className === 'letter-wrapper hover') {
			var letter = document.createElement('div');
			letter.innerText = dv.innerText;
			lW.childNodes[letterWrapperIndex].appendChild(letter);
			letterWrapperIndex++;
			dv.parentNode.removeChild(dv);
			lW.className = 'letter-wrapper';
			ball.callBack('redo');
			if (letterWrapperIndex === lW.childNodes.length) {
				letterWrapperIndex = 0;
				ball.callBack('mouseup');
			}
		} else {
			dv.style.left = '';
			dv.style.top = '';
			dv.style.transform = oldTransform;
			ball.startFoot();
		}
		isDragging = false;
	}
};

export {BallBox,Ball};